import React, { forwardRef } from 'react';

import { resultsPane } from 'src/components/molecules/AddressSearch/styles/styles';

export interface ResultProps
  extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLUListElement>, HTMLUListElement> {
  isContainer: boolean;
  isHighlighted: boolean;
}

export const ResultsPane = forwardRef<HTMLUListElement, ResultProps>(
  (props: ResultProps, forwardedRef) => (
    <ul css={resultsPane} ref={forwardedRef} {...props}>
      {props.children}
    </ul>
  ),
);
